<style lang="sass" scoped>
@import '../../../../../css/core';

.reservations-table-resource-capacities-head {
  .-cell {
    border: 0 solid $border-color-default;
    text-align: right;
    font-weight: bold;
    cursor: pointer;
  }
  .-cell:hover {
    background-color: $background-color-focused;
  }
}
</style>


<template>
<div class="reservations-table-resource-capacities-head">
  <div class="-row">
    <div class="-cell" v-bind:style="cellStyle" @click="toggle">
      <span v-if="isCollapsed" class="glyphicon glyphicon-chevron-down" aria-hidden="true"></span>
      <span v-else class="glyphicon glyphicon-chevron-up" aria-hidden="true"></span>
      <slot name="title">{{ title }}</slot>
    </div>
  </div>
  <slot v-if="!isCollapsed"></slot>
</div>
</template>


<script>
export default {
  name: 'reservations-table-resource-capacities-head',
  mixins: [require('../head.vue')],
  props: {
    title: {
      type: String,
      default: '',
    },
    isCollapsed: {
      type: Boolean,
      twoWay: true,
      default: true,
    },
  },
  methods: {
    toggle() {
      this.isCollapsed = !this.isCollapsed
    }
  }
}
</script>



// WEBPACK FOOTER //
// head.vue?024d7a0a